export const DEMO_INTENT_OPTIONS = {
  internal_testing: {
    key: "internal_testing",
    label: "Internal Testing",
    emoji: "🧪",
    description:
      "Best for QA, validation, bug reproduction, and testing LGV workflows. Expires after 14 days.",
    expiration: {
      enabled: true,
      days: 14,
    },
  },
  customer_demo: {
    key: "customer_demo",
    label: "Customer Demo",
    emoji: "🤝",
    description:
      "Creates a temporary customer-facing Experience that expires after 14 days.",
    expiration: {
      enabled: true,
      days: 14,
    },
  },
  live_example: {
    key: "live_example",
    label: "Live Example",
    emoji: "🌐",
    description:
      "Creates a permanent public example with a clean URL based on the event title.",
    expiration: {
      enabled: false,
      days: 14,
    },
  },
};

export const DEMO_ADDON_OPTIONS = [
  {
    key: "sponsors",
    label: "Sponsors",
    description: "Seed sponsor levels and sponsors.",
  },
  {
    key: "vendors",
    label: "Vendors",
    description:
      "Seed vendors, booth numbers, featured vendors, and map marker labels.",
  },
  {
    key: "tickets",
    label: "Tickets",
    description: "Seed ticket types, paid tickets, and check-in status.",
  },
  {
    key: "auction",
    label: "Silent Auction",
    description: "Seed silent auction items with starting bids and donors.",
  },
  {
    key: "passport",
    label: "Passport",
    description:
      "Seed adaptive Passport activities that use the production redemption workflow.",
  },
  {
    key: "store",
    label: "Event Merch Store",
    description: "Seed merch products, variants, prices, and inventory.",
  },
  {
    key: "social",
    label: "Promotions",
    description:
      "Seed event-scoped Promotion drafts for selected Power Ups.",
  },
];

export const createDefaultAddOnSelection = () =>
  DEMO_ADDON_OPTIONS.reduce(
    (selection, addOn) => ({
      ...selection,
      [addOn.key]: false,
    }),
    {}
  );

export const getDemoIntent = (intentKey = "internal_testing") =>
  DEMO_INTENT_OPTIONS[intentKey] || DEMO_INTENT_OPTIONS.internal_testing;
